export default "__VITE_ASSET__BG8H_zi0__"